module.exports = __webpack_public_path__ + "static/media/fx_logo.dbed0db6.svg";